export default "/shARB.aba9126eb51a9f52777d46c9ce20104d.svg";